import { cloneDeep } from "lodash-es";
import Utils from "../../../../util";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface RevenuesInterface {
 'RESULTS.DATA.ISPL.SP'?: Record<string, ResultRow | Record<string, ResultRow | LCFSRINProduct>>;
 'RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'?: Record<string, ResultRow>;
 'RESULTS.DATA.ISPL.FTF'?: Record<string, ResultRow>;
 'RESULTS.DATA.ISPL.AI'?: Record<string, ResultRow>;
 'RESULTS.DATA.CC'?: Record<string, ResultRow>;
}
export class Revenues {
  'RESULTS.DATA.ISPL.SP';
  'RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'?;
  'RESULTS.DATA.ISPL.FTF'?;
  'RESULTS.DATA.ISPL.AI'?;
  'RESULTS.DATA.CC'?;

  /** selling products */
  get sp() {
    return this['RESULTS.DATA.ISPL.SP'];
  }
  set sp(value: Record<string, ResultRow | Record<string, ResultRow>>) {
    this['RESULTS.DATA.ISPL.SP'] = value;
  }
  get additionalProducts() {
    return this['RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'];
  }
  set additionalProducts(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'] = value;
  }
  /** feedstock tipping fee */
  get ftf() {
    return this['RESULTS.DATA.ISPL.FTF'];
  }
  set ftf(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.ISPL.FTF'] = value;
  }
  /** additional incomes */
  get ai() {
    return this['RESULTS.DATA.ISPL.AI'];
  }
  set ai(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.ISPL.AI'] = value;
  }
  /** carbon credit */
  get cc() {
    return this['RESULTS.DATA.CC'];
  }
  set cc(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.CC'] = value;
  }

  constructor(param: RevenuesInterface = {}) {
    this['RESULTS.DATA.ISPL.SP'] = Utils.ObjectMapper(param['RESULTS.DATA.ISPL.SP'] || {}, makeSoldProducts);

    if (param['RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS']) {
      this['RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'] = Utils.ObjectMapper(
        param['RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'] || {},
        makeSoldProducts
      );
    } else {
      delete this['RESULTS.DATA.ISPL.ADDITIONAL_PRODUCTS'];
    }

    if (param['RESULTS.DATA.ISPL.FTF']) {
      this['RESULTS.DATA.ISPL.FTF'] = Utils.ObjectMapper(param['RESULTS.DATA.ISPL.FTF'] || {}, Utils.toResultRows);
    } else {
      delete this['RESULTS.DATA.ISPL.FTF'];
    }

    if (param['RESULTS.DATA.ISPL.AI']) {
      this['RESULTS.DATA.ISPL.AI'] = Utils.ObjectMapper(param['RESULTS.DATA.ISPL.AI'] || {}, Utils.toResultRows);
    } else {
      delete this['RESULTS.DATA.ISPL.AI'];
    }

    if (param['RESULTS.DATA.CC']) {
      this['RESULTS.DATA.CC'] = Utils.ObjectMapper(param['RESULTS.DATA.CC'] || {}, Utils.toResultRows);
    } else {
      delete this['RESULTS.DATA.CC'];
    }
  }

  deepCopy() {
    return new Revenues(cloneDeep(this));
  }
}

function makeSoldProducts(sp: ResultRow | Record<string, ResultRow> | LCFSRINProductInterface) {
  const keys = Object.keys(sp);
  if (keys.includes('RESULTS.DATA.LABEL') && keys.includes('RESULTS.DATA.VALUES')) {
    return Utils.toResultRows(sp as ResultRow)
  } else if (keys.includes('RESULTS.DATA.D5RINPRICE') && keys.includes('RESULTS.DATA.LCFSPRICE')) {
    return new LCFSRINProduct(sp as LCFSRINProductInterface);
  } else {
    return Utils.ObjectMapper(sp || {}, Utils.toResultRows);
  }
}

interface LCFSRINProductInterface {
 'RESULTS.DATA.D5RINPRICE'?: ResultRow;
 'RESULTS.DATA.LCFSPRICE'?: ResultRow;
 'RESULTS.DATA.NATGASPRICE'?: ResultRow;
}
class LCFSRINProduct {
  'RESULTS.DATA.D5RINPRICE';
  'RESULTS.DATA.LCFSPRICE';
  'RESULTS.DATA.NATGASPRICE';

  constructor(param: LCFSRINProductInterface = {}) {
    if (param['RESULTS.DATA.D5RINPRICE']) {
      this['RESULTS.DATA.D5RINPRICE'] = new ResultRow(param['RESULTS.DATA.D5RINPRICE']);
    }
    if (param['RESULTS.DATA.LCFSPRICE']) {
      this['RESULTS.DATA.LCFSPRICE'] = new ResultRow(param['RESULTS.DATA.LCFSPRICE']);
    }
    if (param['RESULTS.DATA.NATGASPRICE']) {
      this["RESULTS.DATA.NATGASPRICE"] = new ResultRow(param["RESULTS.DATA.NATGASPRICE"]);
    } else {
      delete this['RESULTS.DATA.NATGASPRICE'];
    }
  }

  deepCopy() {
    return new LCFSRINProduct(cloneDeep(this));
  }
}